<template>
  <div class="container">

    <div class="mt-4 mb-2 d-flex justify-content-between">
      <back-arrow :title="$t('tutorial.manage.order')" routeBack="TutorialIndex"/>
    </div>

    <div>
      <div class="row mt-4">
        <div class="col-md-1">
            <div v-for="(element, index) in tutorials" :key="element.id" class="list-item">
              <div class="d-flex index-ordre  justify-content-end mb-1 mx-0">
                <span> {{ index + 1 +"."}} </span>
              </div>
            </div>
        </div>
        <div class="col-md-6">
          <draggable :list="tutorials" class="draggable-list" group="tutorials">
            <div v-for="element in tutorials" :key="element.id" class="list-item">
              <div class="d-flex investor  align-items-center mb-1 mx-0">
                <menu-2-icon size="18"></menu-2-icon>
                <span class="ml-3"> {{ element.title }} </span>
                <span class="ml-auto ">{{ formatDuration(element.duration) }}</span>
              </div>
            </div>
          </draggable>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-7">
          <div class="d-flex justify-content-end">
            <b-button id="validate-btn" variant="primary" @click="updatePriorities">{{ $t('Validate') }}</b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../services/api";
import draggable from 'vuedraggable';
import BackArrow from "../../components/b122/BackArrow.vue";
import {formatDuration, intervalToDuration} from "date-fns";
import {fr} from "date-fns/locale";

export default {
  name: "TutorialUpdateOrder",

  components: {
    BackArrow,
    draggable
  },

  async mounted() {
    await this.fetchData()
  },

  data() {
    return {
      operationId: this.$route.params.operationId,
      isLoading: false,
      tutorials: [],
      bilanType: null,
    }
  },

  methods: {
    async fetchData() {
      await this.fetchTutorials()
    },

    formatDuration(durationMs) {
      if (!durationMs) return 'N/A';
      // Utilise intervalToDuration pour obtenir la durée décomposée en heures, minutes, et secondes
      const duration = intervalToDuration({start: 0, end: durationMs});

      // Utilise formatDuration pour formater en HH:MM:SS
      return formatDuration(duration, {format: ['hours', 'minutes', 'seconds'], locale: fr});
    },


    async fetchTutorials() {
      this.isLoading = true
      api
        .get(`/tutorial/`)
        .then(response => {
          response.data.forEach(tutorial => {
            this.tutorials.push({
              id: tutorial.id,
              title: tutorial.title,
              ordre: tutorial.ordre,
              duration: tutorial.duration
            })
          })
          this.isLoading = false
        })
    },


    updatePriorities() {
      let form = new FormData()
      form.append("tutorials", JSON.stringify(this.tutorials))
      api({
        method: 'POST',
        url: '/tutorial/updatePriorities',
        data: form
      }).then(() => {
        this.successToast()
        this.$nextTick(() => {
          this.$router.push({
            name: 'TutorialIndex',
          })
        })
      }).catch(() => {

      })
    },

    successToast() {
      this.$bvToast.toast(this.$i18n.t('tutorial.order.updated'), {
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: 'success',
        solid: true,
      })
    }

  }
}

</script>

<style scoped>

.investor {
  border-radius: 2px;
  border: solid 1px var(--main-grey);
  padding: 8px;
}

.list-item {
  background-color: #FFFFFF;
}

.index-ordre {
  border-radius: 2px;
  background-color: rgb(243, 243, 243);
  padding: 9px;
}

</style>



// WEBPACK FOOTER //
// src/views/tutorial/TutorialUpdateOrder.vue